import { InlineChildren, InlineChildrenSize } from '@doordash/design-language';
import styled from 'styled-components';

var PhoneContainer = styled(InlineChildren).attrs(function () {
  return {
    size: InlineChildrenSize.XxSmall
  };
}).withConfig({
  displayName: "styles__PhoneContainer",
  componentId: "sc-c3ormv-0"
})(["& > *:first-child{flex-shrink:2;min-width:128px;}& > *:last-child{flex-grow:1;flex-shrink:1;}"]);

export { PhoneContainer };
